<template>
	<button
		type="button"
		role="checkbox"
		:aria-checked="props.modelValue"
		class="flex justify-center items-center w-fit h-fit border-2 border-solid border-primary rounded-md bg-white text-primary cursor-pointer p-1 md:p-2"
		:class="{
			'!bg-primary !text-white': props.modelValue,
			'opacity-70 !cursor-default': props.disabled,
			'!rounded-full': props.checkVariant === 'circle',
		}"
		@click="toggleCheckbox"
	>
		<div
			class="flex justify-center items-center"
			:class="{
				'w-3 h-3 md:w-4 md:h-4': props.size === 'md',
				'size-[1rem] md:size-[1.4rem]': props.size === 'sm'
			}"
		>
			<icon
				:which="props.modelValue
					? 'checkbox-check'
					: 'cross'
				"
			/>
		</div>
	</button>
</template>

<script setup lang="ts">
type Props = {
	modelValue: boolean;
	disabled?: boolean;
	checkVariant?: 'circle' | 'rectangle';
	size?: 'sm' | 'md';
};

const props = withDefaults(defineProps<Props>(), {
	checkVariant: 'circle',
	size: 'md',
});

const emit = defineEmits<{
	'update:modelValue': [ value: boolean ];
}>();

function toggleCheckbox () {
	if (props.disabled) { return; }
	emit('update:modelValue', !props.modelValue);
}
</script>
